import { View } from '@react-pdf/renderer';
import React from 'react';
import type { MyListPageItem } from './MyList';
import ExhibitorSummary from './MyList.ExhibitorSummary';
import ProductRow from './MyList.ProductRow';

export default function ProductList({
  exhibitor,
}: {
  exhibitor: MyListPageItem;
}) {
  return (
    <View style={{ flexGrow: 1 }}>
      {exhibitor.products.length ? (
        exhibitor.products?.map((item, index) => (
          <ProductRow product={item} key={index} />
        ))
      ) : (
        <ExhibitorSummary exhibitor={exhibitor} />
      )}
    </View>
  );
}
